import { redirect } from 'next/navigation';

interface RedirectDetailPageProps {
  returnCode?: number;
  pathname: string;
}

export const redirectDetailPage = ({
  returnCode,
  pathname,
}: RedirectDetailPageProps) => {
  switch (returnCode) {
    case 24040:
      return redirect(`${pathname}?toast=존재하지 않는 페이지입니다.`);
    case 20019:
    case 24041:
      return redirect(`${pathname}?toast=숨김 처리된 페이지입니다.`);
  }
};
